(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    customElements.define('slideshow-inline', class extends Core {
        defaultProps = {
            gap: 20,
            slidesPerView: 4
        }

        elements = {
            swiper: '[data-swiper]'
        }

        render() {
            this._setSwiperProps();
            this._initSwiper();
        }
        
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
        }

        _setSwiperProps() {      

          
            this.swiperProps = {
                // slidesPerView: this.slidesPerView,
                // ,
                  autoplay: this.autoplay,
                loop: this.withLoop,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    1: {
                        slidesPerView: 2.5,
                        spaceBetween: this.gap/2
                    },
                    992: {
                        slidesPerView: this.slidesPerView,
                        spaceBetween: this.gap
                    }
                }
            };
            if(this.withOffset) {
                this.swiperProps.slidesOffsetBefore = this.offset;
                this.swiperProps.slidesOffsetAfter = this.offset;
            }

          if(this.closest('.custom-reviews-section')) {
        
            this.swiperProps.slidesPerView = 1;
             this.swiperProps.breakpoints[1].slidesPerView = 1;
          }

       
          
        }

        get slidesPerView() {
            return this.getAttribute('slides-per-view') 
                && +this.getAttribute('slides-per-view') 
                || this.defaultProps.slidesPerView;
        }
        get gap() {
        
       let gap_index = this.hasAttribute('gap') ?  +this.getAttribute('gap') : this.defaultProps.gap;
         

          return gap_index;
          
            // return this.getAttribute('gap') 
            //     && +this.getAttribute('gap') 
            //     || this.defaultProps.gap;
        }
        get withOffset() {
            return this.hasAttribute('offset');
        }
        get withLoop() {
            return this.hasAttribute('loop');
        }
        get offset() {
            return (window.innerWidth - window.containerInnerWidth) / 2;
        }
         get autoplay() {


            let autoplayAttr = this.getAttribute('autoplay');
            let has_autoplayAttr = this.hasAttribute('autoplay');
            let autoplayVal = false;
            if (has_autoplayAttr == false) {
              autoplayVal = false;
            } else {
             autoplayVal = {delay: +autoplayAttr * 1000}
            }

         
            return autoplayVal;
        }
    })
})();

// (async () => {
//     const { Core } = await importModule('Core');
//     const { Swiper } = await importModule('Swiper');

//     customElements.define('slideshow-inline', class extends Core {
//         defaultProps = {
//             gap: 20,
//             slidesPerView: 4
//         }

//         elements = {
//             swiper: '[data-swiper]'
//         }

//         render() {
//             this._setSwiperProps();
//             this._initSwiper();
//         }
        
//         _initSwiper() {
//             this.swiper = new Swiper(this.$swiper, this.swiperProps);
//         }

//         _setSwiperProps() {
//             this.swiperProps = {
//                 // slidesPerView: this.slidesPerView,
//                 // ,
//                 autoplay: this.autoplay,
//                 loop: this.withLoop,
//                 watchSlidesProgress: true,
//                 navigation: {
//                     nextEl: '.swiper-button-next',
//                     prevEl: '.swiper-button-prev'
//                 },
//                 breakpoints: {
//                     1: {
//                         slidesPerView: 2,
//                         spaceBetween: this.gap/2
//                     },
//                     992: {
//                         slidesPerView: this.slidesPerView,
//                         spaceBetween: this.gap
//                     }
//                 }
//             };
//             if(this.withOffset) {
//                 this.swiperProps.slidesOffsetBefore = this.offset;
//                 this.swiperProps.slidesOffsetAfter = this.offset;
//             }
//         }

//         get slidesPerView() {
//             return this.getAttribute('slides-per-view') 
//                 && +this.getAttribute('slides-per-view') 
//                 || this.defaultProps.slidesPerView;
//         }
//         get gap() {
//             return this.getAttribute('gap') 
//                 && +this.getAttribute('gap') 
//                 || this.defaultProps.gap;
//         }
//         get withOffset() {
//             return this.hasAttribute('offset');
//         }
//         get withLoop() {
//             return this.hasAttribute('loop');
//         }
//         get offset() {
//             return (window.innerWidth - window.containerInnerWidth) / 2;
//         }
//         get autoplay() {
//             let autoplayAttr = this.hasAttribute('autoplay');
//             let autoplayVal = false;
//             if (autoplayAttr == 'false') {
//               autoplayVal = false;
//             } else {
//              autoplayVal = {delay: +autoplayAttr * 1000}
//             }
//             return autoplayVal;
//         }
//     })
// })();